/* eslint-disable import/prefer-default-export */
import React from 'react';

export const PlayIcon = () => (
  <svg width='24' height='24'>
    <rect width='24' height='24' fill='none' rx='0' ry='0' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5349 11.6723L15.1149 10.3323L16.2849 10.9123L14.4549 12.4523L13.5349 11.6723ZM4.375 19.9924V19.3924L12.595 12.4524L13.525 13.2424L5.80501 19.7524L4.795 20.2524C4.665 20.3124 4.565 20.2624 4.515 20.2324C4.455 20.2024 4.375 20.1324 4.375 19.9924Z'
      fill='#1e376c'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.995 11.4124L16.485 9.67243C16.465 9.66243 16.435 9.65243 16.405 9.63243L5.32498 4.16243C4.85498 3.93243 4.31498 3.96243 3.87498 4.23243C3.43498 4.51243 3.17499 4.98243 3.17499 5.50243V19.9924C3.17499 20.5124 3.43498 20.9824 3.87498 21.2524C4.11498 21.4024 4.39499 21.4824 4.66499 21.4824C4.88499 21.4824 5.11498 21.4324 5.32498 21.3224L16.875 15.6224L19.995 14.0824C20.505 13.8324 20.825 13.3124 20.825 12.7424C20.825 12.1724 20.505 11.6624 19.995 11.4124ZM5.80499 19.7524L4.79498 20.2524C4.66498 20.3124 4.56498 20.2624 4.51498 20.2324C4.45498 20.2024 4.37498 20.1324 4.37498 19.9924V5.50243L12.595 12.4524L13.525 13.2424L15.545 14.9424L5.80499 19.7524ZM19.465 13.0024L16.715 14.3624L14.455 12.4524L13.535 11.6724L7.50499 6.58243L15.115 10.3324L16.285 10.9124L19.465 12.4824C19.605 12.5524 19.625 12.6924 19.625 12.7424C19.625 12.8024 19.605 12.9324 19.465 13.0024Z'
      fill='#f47722'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.9949 11.4124L16.485 9.67243C16.465 9.66243 16.435 9.65243 16.405 9.63243L5.32495 4.16243C4.85495 3.93243 4.31495 3.96243 3.87495 4.23243C3.73495 4.32243 3.61495 4.44243 3.51495 4.56243C3.83495 4.86243 4.12495 5.19243 4.37495 5.55243V5.50243L12.595 12.4524L13.5249 13.2424L16.5549 15.7824L19.9949 14.0824C20.5049 13.8324 20.825 13.3124 20.825 12.7424C20.825 12.1724 20.5049 11.6624 19.9949 11.4124ZM19.465 13.0024L16.715 14.3624L14.455 12.4524L13.535 11.6724L7.50496 6.58243L15.1149 10.3324L16.285 10.9124L19.465 12.4824C19.6049 12.5524 19.625 12.6924 19.625 12.7424C19.625 12.8024 19.6049 12.9324 19.465 13.0024Z'
      fill='undefined'
      fillOpacity='undefined'
    />
  </svg>
);

export const ArrowDownIcon = () => (
  <svg width='24' height='24'>
    <rect width='24' height='24' fill='none' rx='50' ry='50' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.06 7.9425C18.47 7.3525 17.52 7.3525 16.94 7.9425L12 12.8825L7.06 7.9425C6.47 7.3525 5.52 7.3525 4.94 7.9425C4.35 8.5325 4.35 9.4825 4.94 10.0625L10.94 16.0625C11.23 16.3525 11.62 16.5025 12 16.5025C12.38 16.5025 12.77 16.3525 13.06 16.0625L19.06 10.0625C19.65 9.4825 19.65 8.5225 19.06 7.9425Z'
      fill='#ffffff'
    />
  </svg>
);

export const AddIcon = () => (
  <svg width='24' height='24'>
    <rect width='24' height='24' fill='none' rx='50' ry='50' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5 20.5C10.5 21.33 11.17 22 12 22C12.83 22 13.5 21.33 13.5 20.5V13.5H20.5C21.33 13.5 22 12.83 22 12C22 11.17 21.33 10.5 20.5 10.5H13.5V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V10.5H3.5C2.67 10.5 2 11.17 2 12C2 12.83 2.67 13.5 3.5 13.5H10.5V20.5Z'
      fill='#f47722'
    />
  </svg>
);

export const SaveIcon = () => (
  <svg width='24' height='24'>
    <rect width='24' height='24' fill='none' rx='0' ry='0' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 4C3 3.44772 3.44772 3 4 3H16.5177C16.8214 3 17.1087 3.13802 17.2984 3.37513L20.7807 7.72604C20.9227 7.90338 21 8.12376 21 8.3509V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM6.2 4.7C6.2 4.42386 6.42386 4.2 6.7 4.2H14.3C14.5761 4.2 14.8 4.42386 14.8 4.7V9.3C14.8 9.57614 14.5761 9.8 14.3 9.8H6.7C6.42386 9.8 6.2 9.57614 6.2 9.3V4.7ZM12.5 5C12.2239 5 12 5.22386 12 5.5V8.5C12 8.77614 12.2239 9 12.5 9H13.5C13.7761 9 14 8.77614 14 8.5V5.5C14 5.22386 13.7761 5 13.5 5H12.5Z'
      fill='#f47722'
    />
  </svg>
);

export const RemoveIcon = () => (
  <svg width='24' height='24'>
    <rect width='24' height='24' fill='none' rx='0' ry='0' />
    <path d="M18.3 5.71a.9959.9959 0 00-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
  </svg>
);
